import Tooltip from "components/Tooltip";
import Twemoji from "react-twemoji";
import { APPROACHABILITY_ICONS } from "sockapi/puzzle-data";

const prefix =
  "This is a rating of how solvable we believe the puzzle is with your current piece unlocks, compared to the puzzle with all of its pieces available.";

const messages = [
  "There is unreasonable additional difficulty compared to the complete version. We do not expect the puzzle to be solvable without more unlocks, but it may still be possible to make significant progress on the puzzle (and it’s up to you whether you want to work on it).",
  "There is moderate additional difficulty compared to the complete version. We expect the puzzle to be solvable, and we recommend working on it, but further unlocks will also be helpful.",
  "There is minimal additional difficulty compared to the complete version. You do not have all the pieces, but the remaining ones are less important to solving the puzzle.",
  "There is no additional difficulty compared to the complete version. You have all the pieces.",
];

export function Approachability(props: {
  approachability: number;
  tooltip: boolean;
}) {
  const approachability = Math.min(3, Math.max(0, props.approachability));

  return props.tooltip ? (
    <div className="approachability">
      <Tooltip text={prefix + "\n\n" + messages[approachability]} into>
        <Twemoji>{APPROACHABILITY_ICONS[approachability]}</Twemoji>
      </Tooltip>
    </div>
  ) : (
    <div className="approachability">
      <Twemoji>{APPROACHABILITY_ICONS[approachability]}</Twemoji>
    </div>
  );
}
